if(!customElements.get('search-product-list')){
    class MainSearchProductList extends HTMLElement {
        constructor(){
            super();

            this.id = this.dataset.id;

            this.inputSearch = this.querySelector('input[name="q"]');
            this.formSearch = this.querySelector('.search-form');
            this.searchProductContent = this.querySelector(".search-product__content");
            this.filterDrawer = document.getElementById('filter-drawer');
        }

        connectedCallback(){
            this.onLoadPaginationSubscriber = PubSub.subscribe(PubSub.events.onLoadPagination, this.handleSearchLoadOnPagination.bind(this));

            this.handleViewSwitch();

            if(this.inputSearch){
                this.inputSearch.addEventListener("input", this.debounce(() => {
                    this.updateSearchInput();
                },300).bind(this));
            }
        }

        handleViewSwitch(){
            this.buttonViewSwitch = this.querySelector('.button-view-switch');
            if(this.buttonViewSwitch){
                this.buttonViewSwitch.addEventListener("click", this.switchView.bind(this));
                this.buttonViewSwitch.addEventListener("keydown", e => {
                    if(e.key === 'Enter'){
                        this.switchView(e);
                    }
                });
            }
        }

        debounce(fn, wait){
            let t;
            return (...args) => {
                clearTimeout(t);
                t = setTimeout(() => fn.apply(this.args), wait);
            }
        }

        disconnectedCallback(){
            if(this.onLoadPaginationSubscriber && typeof this.onLoadPaginationSubscriber === 'function'){
                this.onLoadPaginationSubscriber();
            }
        }

        updateSearchInput(){
            if(!this.formSearch) return;
            
            var params = new URLSearchParams();
            const formData = new FormData(this.formSearch);

            formData.forEach((value, name) => {
                params.append(name, value);
            });

            const queryString = params.toString();
            const formURL = this.formSearch.getAttribute('action');
            const currentURL = `${formURL}${formURL.includes('?')?'&':'?'}${queryString}`;

            this.renderContent({
                requestUrl: `${currentURL}`,
                callback: this.loadContent({
                    requestUrl: `${currentURL}`,
                    callback: () => {}
                })
            });
        }

        handleSearchLoadOnPagination({ data, callback }){
            if(data.type !== 'product') return;

            this.pendingRequestUrl = data.url;
            const currentUrl = data.url || this.pendingRequestUrl;

            setTimeout(() => {
                this.renderContent({
                    requestUrl: `${currentUrl}`,
                    callback: this.loadAppendingContent({
                        callback: callback
                    })
                });
            }, 500);
        }

        renderContent({ requestUrl, callback }){
            this.abortController?.abort();
            this.abortController = new AbortController();

             fetch(requestUrl, { signal: this.abortController.signal })
                .then(res => res.text())
                .then(resText => {
                    this.pendingRequestUrl = null;
                    const html = new DOMParser().parseFromString(resText, 'text/html');
                    callback(html);
                })
                .catch(error => {
                    if(error.name === 'AbortError') {
                        console.log('Fetch aborted by user');
                    }else{
                        console.error(error);
                    }
                });
        }

        loadContent({ requestUrl, callback }){
            return (html) => {
                const searchProductContent = html.querySelector(`.search-product-list[data-id="${this.id}"] .search-product__content`);
                const filterDrawer = html.querySelector('#filter-drawer');

                const buttonViewSwitch = searchProductContent.querySelector('.button-view-switch');
                if(buttonViewSwitch && this.buttonViewSwitch){
                    const minimized = this.buttonViewSwitch.dataset.minimized;
                    if(minimized === 'true'){
                        buttonViewSwitch.setAttribute('data-minimized', 'true');
                    }
                }

                if(this.searchProductContent && searchProductContent){
                    this.searchProductContent.innerHTML = searchProductContent.innerHTML;
                    const data = {
                        requestUrl: requestUrl
                    }
                    PubSub.publish(PubSub.events.facetUpdate, { data: data });
                }

                if(this.filterDrawer && filterDrawer){
                    this.filterDrawer.querySelector('.filter-drawer__content').innerHTML = filterDrawer.querySelector(".filter-drawer__content").innerHTML;

                    PubSub.publish(PubSub.events.filterDrawerUpdate, {});
                }

                this.handleViewSwitch();
            }
        }

        loadAppendingContent({ callback }){
            return (html) => {
                const productListWrapper = html.querySelector(`.search-product-list[data-id="${this.id}"]`);
                this.productList = this.querySelector(".product-list");
                if(productListWrapper){
                    const productList = productListWrapper.querySelector('.product-list');
                    if(this.productList && productList){
                        Array.from(productList.children).forEach(child => {
                            this.productList.appendChild(child.cloneNode(true));
                        });
                    }

                    const autoPagination = html.querySelector('auto-pagination');
                    if(autoPagination){
                        const url = autoPagination.dataset.url;
                        callback(url);
                    }
                }
            }
        }

        switchView(e){
            if(!this.buttonViewSwitch) return;

            if(this.buttonViewSwitch.dataset.minimized === 'true'){
                this.buttonViewSwitch.setAttribute("data-minimized", 'false');
                this.classList.remove('minimized');
            }else{
                this.buttonViewSwitch.setAttribute("data-minimized", 'true');
                this.classList.add('minimized');
            }
        }
    }

    customElements.define('search-product-list', MainSearchProductList);
}